import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './src/context/auth-context'
import './src/styles/global.css'

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => (
  <AuthProvider>
    <GoogleOAuthProvider clientId="438051520688-jaql7dv6b3f5e428h9ba8sd2sbmuoope.apps.googleusercontent.com">
      {element}
    </GoogleOAuthProvider>
  </AuthProvider>
);
